/* eslint-disable camelcase */
/* eslint-disable max-classes-per-file */
import Vue from 'vue';
import Component from 'vue-class-component';
import { getFirstLettersFromText } from 'RootDir/common/helpers';
import { ROLES } from 'RootDir/common/constants';

declare module 'vue/types/vue' {
  interface Vue {
    $currentUser: CurrentUser;
  }
}

class CurrentUser {
  id!: number;

  token!: string;

  is_superadministrator!: boolean;

  is_root!: boolean;

  department_id!: number;

  role_id!: number;

  first_name!: string;

  last_name!: string;

  middle_name!: string;

  photo_link!: string | any;

  phone!: string;

  email!: string;

  login!: string;

  permissions!: Array<string>;

  constructor(data) {
    Object.keys(data).forEach(key => {
      this[key] = data[key];
    });
  }

  get firstLetters() {
    return getFirstLettersFromText(`${this.last_name} ${this.first_name}`);
  }

  get fullName() {
    return `${this.last_name} ${this.first_name}`;
  }

  get fio() {
    return `${this.last_name} ${this.first_name} ${this.middle_name}`;
  }

  get isRoot(): boolean {
    return !!this.is_superadministrator;
  }

  get isAdministrator(): boolean {
    return this.role_id === ROLES.ADMINISTRATOR || this.isRoot;
  }

  get isOperator(): boolean {
    return this.role_id === ROLES.OPERATOR || this.isAdministrator;
  }

  get departmentId(): number {
    return this.department_id;
  }
}

@Component
export default class UserStuffHelpersVue extends Vue {
  get $currentUser(): CurrentUser {
    // if(!this.$store.getters['user/isEmptyUser']) {
      return new CurrentUser(this.$store.getters['user/user']);
    // }
  }
}
